import {
    collection,
    component,
    EntityData,
    field,
    identifier,
    LocalisableEntityData,
    transientField
} from "@fedeltapointofsale/data-client";
import {MetaTagDefinitionReferenceData} from "../../catalogue/meta-tag/meta-tag.data";
import {OutletReferenceData} from "../../pos/outlet/outlet.data";
import {OrderTypeInfoData} from "../order-type/order-type-info.data";

export class OrderAssignmentRuleData extends LocalisableEntityData<OrderAssignmentRuleData> {
    @identifier id: number;
    @field name: string;
    @field includeCompositeItems: boolean;
    @component preparationOutlet: OutletReferenceData;
    @collection(MetaTagDefinitionReferenceData) tags: MetaTagDefinitionReferenceData[];
    @collection(OutletReferenceData) outlets: OutletReferenceData[];
    @collection(OrderTypeInfoData) orderTypes: OrderTypeInfoData[];

    private _orderTypeIds: number[];

    @transientField get orderTypeIds(): number[] {
        if (!this._orderTypeIds && this.orderTypes) {
            this._orderTypeIds = this.orderTypes.map(value => value.orderType);
        }
        return this._orderTypeIds;
    }

    set orderTypeIds(types: number[]) {
        this._orderTypeIds = types;
        if (types) {
            this.ednProxy.orderTypes = types.map((value) => {
                const entity: OrderTypeInfoData = <OrderTypeInfoData>EntityData.create(OrderTypeInfoData);
                entity.orderType = value;
                return entity;
            });
        } else {
            this.orderTypes = undefined;
        }
    }
}
